import script from "./BottomBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=21f5093c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f5093c"]])

export default __exports__